import React from "react";
import { Drawer } from "antd";
import { createGlobalStyle } from "styled-components";
import ConsentManagementContent from "./ConsentManagementContent";
import { GRAY_50, PRIMARY_600 } from "../../constant/colors";

// Force the drawer to have correct height - ONLY affects this specific drawer
// TODO: think about this
const ConsentDrawerStyles = createGlobalStyle`
  .consent-management-drawer {
    .ant-drawer-content-wrapper {
      height: 571px !important;
      top: calc(50% - 285.5px) !important;
      bottom: auto !important;
      border-radius: 20px 0 0 20px !important;
    }
    
    .ant-drawer-content {
      height: 571px !important;
      border-radius: 20px 0 0 20px !important;
      box-shadow: 0px 24px 40px 0px rgba(0, 0, 0, 0.07) !important;
      border-right: 1px solid ${PRIMARY_600} !important;
      overflow: hidden !important;
    }

    .ant-drawer-body {
      padding: 0 !important;
      background-color: ${GRAY_50} !important;
      height: 100% !important;
      overflow: hidden !important;
    }
    
    /* Ensure header also respects border radius */
    .ant-drawer-header {
      border-radius: 20px 0 0 0 !important;
    }
  }
`;

const ConsentManagementDrawer = ({ visible, onClose }) => {
  return (
    <>
      <ConsentDrawerStyles />
      <Drawer
        open={visible}
        onClose={onClose}
        placement="right"
        mask={false}
        closable={false}
        destroyOnClose
        width={542}
        className="consent-management-drawer"
      >
        <ConsentManagementContent onClose={onClose} />
      </Drawer>
    </>
  );
};

export default ConsentManagementDrawer;
